// checkFields.js
import { validators } from "./validators.js";


// ✅ Vérifie un champ individuellement
export function checkField(elOrName, options = {}) {
    let el  =null;
    if (typeof elOrName === "string"){
        const elems = document.getElementsByName(elOrName);
        if (elems.length > 0){
            el = elems[0];
        } else throw new Error("checkField : champ introuvable : " + elOrName);
    } else {
        el = elOrName;
    }

    if (!el) return []; // si champ introuvable → pas d’erreurs

    const fieldErrors = [];

    if (el.type === "checkbox" || el.type === "radio") {
        if (el.required) {
            // Pour les radios, vérifier tout le groupe par `name`
            if (el.type === "radio") {
                const group = document.querySelectorAll(`[name="${el.name}"]`);
                const checked = [...group].some(r => r.checked);
                if (!checked) {
                    fieldErrors.push("required");
                }
            } else if (el.type === "checkbox" && !el.checked) {
                fieldErrors.push("required");
            }
        }
    }

    // Vérifs HTML natives
    if (!options.hasOwnProperty('innerRules') || options.innerRules === true) {
        for (const [ruleName, validatorFn] of Object.entries(validators)) {
            const result = validatorFn(el);
            if (result !== true) {
                fieldErrors.push(result);
            }
        }
    }

    // Vérifs custom
    if (options.hasOwnProperty('customRules')) {
        for (const [ruleName, fn] of Object.entries(options.customRules)) {
            const result = fn(el);
            if (result !== true) {
                fieldErrors.push(result);
            }
        }
    }

    //console.log("checkField : " + fieldErrors);
    return Object.keys(fieldErrors).length === 0 ? true : fieldErrors;
}

/**
 * ✅ Vérifie une liste de champs
 * Définitions attendues :
 * {
 *   emailRecup: { innerRules: true, customRules: { checkTld } },
 *   nom: { innerRules: true }
 * }
 * NB : innerRules peut être omis, il sera considéré comme = true
 */
export function  checkFields(defs) {
    const errors = {};

    for (const [id, options] of Object.entries(defs)) {
        const fieldErrors = checkField(id, options);
        if (fieldErrors !== true) {
            errors[id] = fieldErrors;
        }
    }

    return Object.keys(errors).length === 0 ? true : errors;
}